import { Box } from "@twilio-paste/core/box";
import { Table, TBody, Td, Th, THead, Tr } from "@twilio-paste/core/table";
import React from "react";
import { Element } from "react-scroll";
import { Member } from "types";
import { AnchoredHeading, Code } from "../../shared/components";
import { SITE_SCROLL_MARGIN } from "../../shared/constants";
import { codify } from "../../utils/stringUtils";

const headers = ["Name", "Type", "Description"];

function ComponentMembers(props: { members: Partial<Member>[] }) {
    const { members } = props;

    if (!members.length) {
        return null;
    }

    return (
        <Element id="static-properties" name="static-properties" style={{ scrollMarginTop: SITE_SCROLL_MARGIN }}>
            <Box paddingBottom="space200" as="section">
                <AnchoredHeading as="h3" variant="heading30">
                    Static Properties
                </AnchoredHeading>
                <Box overflow="auto">
                    <Box minWidth={["size80", undefined, undefined]}>
                        <Table>
                            <THead>
                                <Tr>
                                    {headers.map((header) => (
                                        <Th key={header}>{header}</Th>
                                    ))}
                                </Tr>
                            </THead>
                            <TBody>
                                {members.map((member) => (
                                    <Tr key={member.name}>
                                        <Td>{member.name}</Td>
                                        <Td>
                                            <Code as="code">{member.type?.names?.[0]}</Code>
                                        </Td>
                                        <Td>
                                            <div dangerouslySetInnerHTML={{ __html: codify(member.description) }} />
                                        </Td>
                                    </Tr>
                                ))}
                            </TBody>
                        </Table>
                    </Box>
                </Box>
            </Box>
        </Element>
    );
}

export { ComponentMembers };
